import { render, staticRenderFns } from "./topbar-notifications.vue?vue&type=template&id=2e3d1198&scoped=true&"
import script from "./topbar-notifications.vue?vue&type=script&lang=js&"
export * from "./topbar-notifications.vue?vue&type=script&lang=js&"
import style0 from "./topbar-notifications.vue?vue&type=style&index=0&id=2e3d1198&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d1198",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3d1198')) {
      api.createRecord('2e3d1198', component.options)
    } else {
      api.reload('2e3d1198', component.options)
    }
    module.hot.accept("./topbar-notifications.vue?vue&type=template&id=2e3d1198&scoped=true&", function () {
      api.rerender('2e3d1198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/topbar-notifications.vue"
export default component.exports